import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify';
import axios from "axios";
import VueAxios from "vue-axios";
import VueDayjs from 'vue-dayjs-plugin';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import VueGlobalVar from 'vue-global-var';
import '@mdi/font/css/materialdesignicons.css'
import {store} from '@/store/store'
import { VueMaskFilter } from 'v-mask'
import i18n from '@/i18n'

var isElectron=false

if(process.platform!='browser'){
  console.log('process : ',process)
  console.log('version : ',process.versions)
  console.log('plateform : ',process.platform)
  if (typeof (process.versions.electron) === 'string') {
    console.log('electron is true')
    isElectron=true
    
    //electron stuff
    const { app,dialog } = window.require('electron').remote;
    const Store = window.require('electron-store');
    const db = new Store();
    
    store.dispatch('loadElectronDb')
    
    
    Vue.use(VueGlobalVar, {
      globals: {
        $app: app,
        $db:db,
        $isElectron:isElectron,
        $dialog:dialog
      },
    });
    }
}


Vue.filter('VMask', VueMaskFilter);

Vue.config.productionTip = false;



Vue.use(VueDayjs);
Vue.use(VueAxios, axios);
Vue.use(VueFilterDateParse);
Vue.use(VueFilterDateFormat, {
  dayOfWeekNames: [
    'Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves',
    'Viernes', 'Sabado'
  ],
  dayOfWeekNamesShort: [
    'Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'
  ],
  monthNames: [
    'Enero','Febrero','Marzo','Abril','Mayo','Junio',
    'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
  ],
  monthNamesShort: [
    'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ],
  // Timezone offset, in minutes (0 - UTC, 180 - Russia, undefined - current)
  timezone: 0
});

Vue.use(vuetify, {
  iconfont: 'mdi'
})

router.beforeEach((to,from,next)=>{

  let language = to.params.lang;
  if(!language){
    language='en'
  }

  i18n.locale=language
  next()
})

new Vue({
  store:store,
  router,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
